'use strict';

angular
	.module('mx.SolutionBuilderAgent')
	.controller('mx.SolutionBuilderAgent.ImageSelectionViewController', ['mx.SolutionBuilderAgent.Http', '$q', '$scope', 'mx.internationalization', MxImageSelectionView]);

function MxImageSelectionView(http, $q, $scope, $i18n) {
	const vm = this;
	let typing = 0;

	vm.i18n = $i18n.get('solutionBuilderAgent.layouts.image-selection-tab');
	vm.i18nCommon = $i18n.get('solutionBuilderAgent.common');

	vm.loading = true;

	vm.$onInit = function () {
		vm.selectedImage = vm.selectedImage || '';
		vm.seletedImageSize = '';
		vm.attachment = '';
		vm.initialImage = vm.selectedImage;

		vm.iconsLibrary = [];

		const loadDefers = [];

		if (vm.modeIcon) {
			loadDefers.push(initLibraryView());
		}

		if (vm.modeImage) {
			loadDefers.push(initFolderView());
		}
		if (vm.modeAttach) {
			loadDefers.push(initAttachmentView());
		}

		$q.all(loadDefers).then(function () {
			$scope.$evalAsync(function () {
				selectPickerView();
				vm.loading = false;
			});
		});
	};

	// Folder tab methods
	vm.selectFolder = selectFolder;
	vm.goToParent = goToParent;
	vm.goToPath = goToPath;
	vm.goToRoot = goToRoot;

	vm.preview = function (event, value, size) {
		vm.selectedImage = value;
		vm.seletedImageSize = size;
	};

	vm.select = function () {
		if (vm.attachment && vm.selectedImage !== vm.attachment) {
			// ??????
			http.remove(vm.attachment);
		}
		vm.finishDefer.resolve({
			status: 'OK',
			selectedImage: vm.selectedImage,
		});
	};

	vm.cancel = function () {
		vm.finishDefer.resolve({
			status: 'CANCEL',
			selectedImage: vm.initialImage,
		});
	};

	return vm;

	function initFolderView() {
		return getFolders()
			.then(function (res) {
				vm.rootFolder = mapData(res);
				if (vm.baseFolder) {
					const found = findPath(vm.baseFolder);
					vm.rootFolder = found || vm.rootFolder;
				}
				vm.selectedFolder = vm.rootFolder;
				setFoldersPathView(vm.selectedFolder.path);
				vm.imageModeLoaded = true;
			})
			.then(function () {
				loadFiles(vm.rootFolder.path);
			});
	}

	async function getFolders() {
		if (vm.serverBasePath) {
			if (isBasePathAllowed()) {
				return http.get(`api/resources/imageFolders?path=${vm.serverBasePath}`);
			}

			return [];
		}

		return http.get('api/resources/imageFolders');
	}

	function initLibraryView() {
		$scope.$watch('vm.searchLibraryText', function (text) {
			if (!vm.iconsLibrary) {
				return;
			}
			searchLibrary(text);
		});
		return initLibrary();
	}

	function initAttachmentView() {
		vm.attachment = vm.selectedImage.toLowerCase().includes('api/filestorage') ? vm.selectedImage : '';
		$scope.$watch('vm.attachment', function (newVal, oldVal) {
			if (oldVal !== vm.selectedImage && !newVal) {
				return;
			}
			vm.selectedImage = vm.attachment;
		});
		vm.attachModeLoaded = true;
		return $q.when(true);
	}

	function selectPickerView() {
		const modeAttachOnly = vm.modeAttach && !vm.modeImage && !vm.modeIcon;
		const modeImageOnly = !vm.modeAttach && vm.modeImage && !vm.modeIcon;
		const modeIconOnly = !vm.modeAttach && !vm.modeImage && vm.modeIcon;

		const valueImage = vm.selectedImage.indexOf('/') > -1 || vm.selectedImage.split('.').length > 1;
		const valueAttach = vm.selectedImage.toLowerCase().includes('api/filestorage');
		const tabs = [
			{
				active: vm.modeImage,
				byValue: valueImage,
				mode: 'image',
				only: modeImageOnly,
			},
			{
				active: vm.modeIcon,
				byValue: !valueImage && !valueAttach,
				mode: 'icon',
				only: modeIconOnly,
			},
			{
				active: vm.modeAttach,
				byValue: valueAttach,
				mode: 'attach',
				only: modeAttachOnly,
			},
		];

		_.filter(tabs, 'active').forEach(function (tab, i) {
			tab.index = i;
			if (tab.only || tab.byValue) {
				vm.selectedTabIndex = i;
			}
		});

		vm.tabs = {};
		vm.tabs.image = tabs[0];
		vm.tabs.icon = tabs[1];
		vm.tabs.attach = tabs[2];
	}

	function initLibrary() {
		vm.iconsLibrary = mx.components.Icons.map(function (cat) {
			cat.icons.forEach(function (icon) {
				icon.visible = true;
			});
			return {
				name: cat.name,
				visible: true,
				icons: cat.icons.map(function (icon) {
					return {
						visible: true,
						icon: icon,
					};
				}),
			};
		});
		vm.iconModeLoaded = true;

		return $q.when(vm.iconsLibrary);
	}

	function searchLibrary(inputText) {
		let text = inputText;
		typing++;
		const i = typing;

		setTimeout(function () {
			if (i === typing) {
				typing = 0;

				let found = false;
				text = (text || '').toLowerCase();

				vm.iconsLibrary.forEach(function (category) {
					let catVisible = false;
					category.icons.forEach(function (item) {
						item.visible = item.icon.name.indexOf(text) !== -1 || item.icon.id.indexOf(text) !== -1;
						catVisible = catVisible || item.visible;
					});

					category.visible = catVisible;
					found = found || category.visible;
				});
				vm.itemsFound = found;
				$scope.$apply();
			}
		}, 200);
	}

	function selectFolder(event, folder) {
		if (event && event.stopPropagation) {
			event.stopPropagation();
		}

		if (vm.selectedFolder.path !== folder.path) {
			vm.selectedFolder = folder;

			const path = vm.selectedFolder.path;
			setFoldersPathView(path);
			if (vm.selectedFolder.files === null) {
				vm.folderLoading = true;
				loadFiles(path);
			}
		}
	}

	async function loadFiles(path) {
		let imagesEndpoint = 'api/resources/images';
		let imagesPath = path || '';
		let queryParams = [];
		const serverBasePath = (vm.serverBasePath || '').replaceAll('\\', '/');

		if (vm.modeImage && serverBasePath) {
			if (!isBasePathAllowed()) {
				return;
			}

			queryParams.push(`path=${serverBasePath}`);
		}

		if (path) {
			queryParams.push(`folder=${path}\\`);
		}

		if (queryParams.length > 0) {
			imagesEndpoint += `?${queryParams.join('&')}`;
		}

		try {
			const res = await http.get(imagesEndpoint);
			const files = mapFiles(res, imagesPath, serverBasePath);

			vm.selectedFolder.files = files;
		} catch (err) {
			console.error(err);
			vm.folderError = err;
		} finally {
			vm.folderLoading = false;
		}
	}

	function isBasePathAllowed() {
		const allowedBasePaths = ['/sps/', '/wm/', '\\sps\\', '\\wm\\'];

		if (allowedBasePaths.some((x) => vm.serverBasePath.toLowerCase().startsWith(x)) && !vm.serverBasePath.includes('..')) {
			return true;
		}

		return false;
	}

	function findPath(path) {
		if (path === '' || path === '/') {
			return vm.rootFolder;
		}

		return findFolder(vm.rootFolder.folders, path);
	}

	function goToPath(event, path) {
		if (vm.selectedFolder.path !== path) {
			const found = findPath(path);
			if (found) {
				selectFolder(event, found);
			}
		}
	}

	function setFoldersPathView(path) {
		const newFolderPath = [vm.rootFolder];

		if (path !== '' && path !== '/') {
			const parts = path.split('/');
			if (parts.length > 0) {
				let currPath = '';
				parts.forEach(function (pathPart) {
					currPath += currPath ? '/' + pathPart : pathPart;
					newFolderPath.push(findPath(currPath));
				});
			}
		}
		$scope.$evalAsync(function () {
			vm.folderPath = newFolderPath;
		});
	}

	function goToParent(event, folder) {
		if (folder.parentPath === '') {
			goToRoot(event);
		}
		goToPath(event, folder.parentPath);
	}

	function findFolder(folders, pathToFind) {
		let found = _.find(folders, { path: pathToFind });
		if (!found) {
			folders.some(function (fdr) {
				found = findFolder(fdr.folders, pathToFind);
				return typeof found !== 'undefined';
			});
		}
		return found;
	}

	function goToRoot(event) {
		if (event && event.stopPropagation) {
			event.stopPropagation();
		}
		vm.selectedFolder = vm.rootFolder;
	}

	function mapData(res) {
		return {
			folders: (res || []).map(function (folder) {
				return mapFolder(folder, '');
			}),
			name: vm.i18n.rootFolder,
			path: '',
		};
	}

	function mapFolder(folder, parentPath) {
		const path = (parentPath ? parentPath + '/' : '') + folder.Name;
		return {
			files: null,
			folders: (folder.SubFolders || []).map(function (sf) {
				return mapFolder(sf, path);
			}),
			name: folder.Name || '',
			parentPath: parentPath,
			path: path,
		};
	}

	function mapFiles(res, path, relativePath) {
		return (res || []).map(function (file) {
			let filePath = `${path}/${file.Name}`;

			if (filePath.indexOf('/') === 0) {
				filePath = filePath.substr(1);
			}

			if (relativePath) {
				if (!relativePath.endsWith('/')) {
					relativePath = `${relativePath}/`;
				}

				if (!relativePath.startsWith('/')) {
					relativePath = `/${relativePath}`;
				}

				filePath = `${relativePath}${filePath}`;
			}

			return {
				name: file.Name,
				path: filePath,
				size: file.Size,
			};
		});
	}
}
